import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type {FC, ReactElement} from 'react';

//TYPES
type Props = {
  value: string | number;
  icon: ReactElement;
  label: string;
  direction?: 'row' | 'column';
};

const ValueLabelForPopUp: FC<Props> = ({value, icon, label, direction = 'row'}) => {
  return (
    <Stack
      direction={direction}
      sx={{justifyContent: 'space-between', alignItems: 'flex-start', flex: 1, my: 1, gap: direction === 'row' ? 2 : 0}}
    >
      <Stack direction="row" spacing={1} sx={{justifyContent: 'center'}}>
        {icon}
        <Typography variant="body2" sx={{color: 'grey.700', pt: 0.25}}>
          {label}
        </Typography>
      </Stack>
      <Typography variant="body2" sx={{color: 'common.black', fontWeight: 700, mt: 0.25}}>
        {value}
      </Typography>
    </Stack>
  );
};
export default ValueLabelForPopUp;
